class SplitText {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const windowWidth = $(window).width();
    const windowSm = 768;
    if (windowWidth <= windowSm) {
    //横幅768px以下（スマホ）に適用させるJavaScriptを記述
    
    } else {
      var elm = document.createElement("p");
      var txt = document.createTextNode("\u00a0");
      elm.appendChild(txt);
      document.body.appendChild(elm);

      let splitTarget = document.querySelectorAll('.js-splitText'); //ターゲットとなる要素を全取得
      splitTarget.forEach((target) => {
        if(!target.classList.contains('is-active')){ //ターゲットが'is-active'クラスを持っていない場合
          let newText = ''; //生成する要素を格納するための変数
          const spanText = target.innerHTML; //ターゲットの中身を取得
  
          spanText.split('').forEach((char) => { // char = character 文字
            newText += '<span>' + char + '</span>'; //一文字ずつspanタグで囲む
          });
  
          const newTextBefore = "<div class='before'>"+newText+"</div>"; //beforeクラスをつけた要素を生成
          const newTextAfter = "<div class='after'>"+newText+"</div>"; //afterクラスをつけた要素を生成
          newText = "<span class='text-wrap'>"+newTextBefore + newTextAfter+"</span>"; //before after両要素を囲む要素生成
          target.innerHTML = newText; //ターゲットに生成した要素を挿入
        }
      });
  
      /* ターゲットにホバーした時の動き */
      splitTarget.forEach((target)=>{
        if(!target.classList.contains('is-active')){//ターゲットが'is-active'クラスを持っていない場合
          let beforeSpan = target.querySelector('.before').querySelectorAll('span');//beforeの中にあるspanタグを全取得
          let afterSpan = target.querySelector('.after').querySelectorAll('span');//afterの中にあるspanタグを全取得
          target.addEventListener('mouseenter',()=>{//ホバーしたとき
            gsap.to(beforeSpan,{y:'-100%',stagger:.03,ease:"power2.out"})//0.03秒おきに各spanタグをy軸上に移動
            gsap.to(afterSpan,{y:'0%',stagger:.03,ease:"power2.out"})
          })
          target.addEventListener('mouseleave',()=>{//ホバーが外れたとき
            gsap.to(beforeSpan,{y:'0%',stagger:.03,ease:"power2.out"})
            gsap.to(afterSpan,{y:'100%',stagger:.03,ease:"power2.out"})
          })
        }
      })
    }
  }
}
